import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import CommomTagAndPillsCardBody from "../Common/CommomTagAndPillsCardBody";
import { ROUNDED_PILLS_CONTEXT, ROUNDED_PILLS_DATA } from "../../../../Data/UiKit/BadgesContextualVariations";
import { RoundedPillsWithIcons } from "../../../../Constant";

const RoundedPillsWithIconsCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={RoundedPillsWithIcons} span={ROUNDED_PILLS_DATA} />
        <CommomTagAndPillsCardBody number={ROUNDED_PILLS_CONTEXT} />
      </Card>
    </Col>
  );
};

export default RoundedPillsWithIconsCart;
